module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Ingresos y egresos ",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Ingresos"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" y egresos ")])], 2)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Ingresos y egresos',
      "videoEmbed": "ADMINISTRACIONDINERO15IngresosEgresos (ant46).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_2 aligner",
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('p', {
    staticClass: "text-box adorn-bottom"
  }, [_vm._v("\n        Si los\n        "), _c('strong', [_vm._v("ingresos o entradas")]), _vm._v(" son mayores a los\n        "), _c('strong', [_vm._v("gastos o salidas")]), _vm._v(", el flujo de caja es\n        "), _c('strong', [_vm._v("positivo "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("(+)")])]), _vm._v(". Si los\n        "), _c('strong', [_vm._v("gastos o salidas")]), _vm._v(" son mayores a los\n        "), _c('strong', [_vm._v("ingresos o entradas")]), _vm._v(", el flujo de efectivo es\n        "), _c('strong', [_vm._v("negativo "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("(-)")])]), _vm._v("."), _c('br'), _c('br'), _vm._v(" Un\n        "), _c('strong', [_vm._v("flujo de efectivo")]), _vm._v(" positivo significa poder pagar las cuentas a tiempo y poder cubrir cualquier otro gasto inmediato. Pero lo más importante es que permite\n        "), _c('strong', [_vm._v("ahorrar")]), _vm._v(" para la seguridad financiera frente a una emergencia, para adquirir un bien más adelante o para el momento del retiro.\n        "), _c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "audios": [
        'admin3y4juntos.mp3'
      ]
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "aligner animated fadeIn dura_2",
    attrs: {
      "xs12": "",
      "sm5": "",
      "md5": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 230,
      "imaSrc": "contenido/diapositiva_16",
      "imaAlt": "Mujer sonriendo con la mano en la cintura"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55abe6bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-15.vue
// module id = 985
// module chunks = 1